const hasValidHostname = (hostname: string): boolean => {
  if (!hostname) {
    return false;
  }

  // Require at least one dot and a 2+ char TLD segment.
  const segments = hostname.split('.');
  if (segments.length < 2) {
    return false;
  }

  const tld = segments[segments.length - 1];
  return tld.length >= 2;
};

export const isHttpUrl = (value?: string | null): boolean => {
  if (!value) {
    return false;
  }

  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return false;
  }

  try {
    const parsed = new URL(trimmedValue);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return false;
    }

    return hasValidHostname(parsed.hostname);
  } catch {
    return false;
  }
};
